import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const fetchPartAudit = (params = {}) => apiActionCreator({
  'endpoint': `/audit-parts/detail${getUrlParameters(params)}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_PART_AUDIT,
    ActionTypes.FETCHED_PART_AUDIT,
    [
      ActionTypes.FETCHED_PART_AUDIT_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const downloadPartAuditFile = (params = {}) => apiActionCreator({
  'endpoint': `/audit-parts/detail/excel${getUrlParameters(params)}`,
  'authenticated': true,
  'types': [
    ActionTypes.DOWNLOADING_PART_AUDIT_FILE,
    ActionTypes.DOWNLOADED_PART_AUDIT_FILE,
    [
      ActionTypes.DOWNLOADED_PART_AUDIT_FILE_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const deletePartAudit = () => ({
  'type': ActionTypes.DELETE_PART_AUDIT_DATA,
});
